import { Dispatch } from 'react';

import { transformDateFormat } from 'susy-common/date-utils';

import { ProjectModel, PostDispatch } from '../types';
import { SuSyApi } from '../../api/susyApi';
import { MySupervisionsActionType } from '../actionTypes/mySupervisions';

export const firstSupervisorReviewProjectChanges =
    (project: ProjectModel) => async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.post(
            `/project-management/firstSupervisor/${project._id}/reviewProjectChanges`,
            project
        );
        dispatch({
            type: MySupervisionsActionType.REVIEW_PROJECT_CHANGES,
            payload: response.data,
        });
    };

export const secondSupervisorReviewProjectChanges =
    (project: ProjectModel) => async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.post(
            `/project-management/secondSupervisor/${project._id}/reviewProjectChanges`,
            project
        );
        dispatch({
            type: MySupervisionsActionType.REVIEW_PROJECT_CHANGES,
            payload: response.data,
        });
    };

export const secondSupervisorAccept =
    (project: ProjectModel) => async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.post(
            `/project-management/supervisors/${project._id}/secondSupervisorAccept`,
            project
        );
        dispatch({
            type: MySupervisionsActionType.APPROVE_PROJECT,
            payload: response.data,
        });
    };

export const secondSupervisorDecline =
    (project: ProjectModel) => async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.post(
            `/project-management/supervisors/${project._id}/secondSupervisorDecline`,
            project
        );
        dispatch({
            type: MySupervisionsActionType.DECLINE_PROJECT,
            payload: response.data,
        });
    };

export const declineProject =
    (project: ProjectModel) => async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.post(
            `/project-management/supervisors/${project._id}/declineProject`,
            project
        );
        dispatch({
            type: MySupervisionsActionType.DECLINE_PROJECT,
            payload: response.data,
        });
    };

export const approveProject =
    (project: ProjectModel) => async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.post(
            `/project-management/supervisors/${project._id}/approveProject`,
            project
        );
        dispatch({
            type: MySupervisionsActionType.APPROVE_PROJECT,
            payload: response.data,
        });
    };

export const getMySupervisions =
    () => async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.get(
            `/project-management/supervisors/mysupervisions`
        );

        dispatch({
            type: MySupervisionsActionType.GET_MY_SUPERVISIONS,
            payload: transformDateFormat(response.data),
        });
    };
